export default {"src":"/_next/static/media/assistant-fixer.1e86286b.svg","height":203,"width":239};